import { CancelablePromise } from "@/api/generated/core/CancelablePromise"

export async function getResponseBody<T>(promise: CancelablePromise<T>) {
  const response = await promise
  return response.body
}
